<div class="orders-grid-container">
  @if (hasOrders()) {
    <div class="ag-grid-wrapper">
      <dw-grid-ag-grid
        #agGrid
        [inputRowData]="orders() ?? []"
        [columnDefs]="columnDefs"
        [hasPagination]="false"
        [hideFilter]="true"
        [hidePanelColumn]="true"
        [autoSize]="false"
        [(selectedRows)]="selectedRows"
        (selectedRowsChange)="onSelectedRowsChange()"
        (gridReady)="onGridReady()"
      >
      </dw-grid-ag-grid>
    </div>
  } @else if (hasNoOrders()) {
    <div class="no-data-message">
      <div class="text-center text-muted py-4">
        <i class="fa fa-info-circle fa-2x mb-2"></i>
        <p>{{ 'Doc::CustomerSalesPurchase:NoOrdersToPrepare' | abpLocalization }}</p>
      </div>
    </div>
  }
</div>
